export default "__VITE_ASSET__I_IqeZVv__"